import React from "react"
import { FieldItems } from "@tenforce/toolbox-field-react"
import { NewTable } from "@tenforce/toolbox-table-react"
import {
    Action,
    ActionAnchor,
    ActionType,
} from "@tenforce/toolbox-button-push-react"

import { IItemPickerField } from "../.."
import { useAppDispatch, useAppSelector } from "../../../../hooks"
import { GlobalState } from "../../../../store"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { Exceptions, Labels } from "../../../../util/Translations"
import { updateField } from "../../slice"
import ItemAncestry from "./ItemAncestry"
import { itemDetailUrl } from "../../../../util/UrlGenerator"
import env from "../../../../env"
import { ITenForceWindow } from "../../../../global"
import { addErrorNotification } from "../../../notifications/actions"

type Props = IItemPickerField

declare let window: ITenForceWindow

const ItemPicker: React.FC<Props> = (props: Props) => {
    const dispatch = useAppDispatch()
    const {
        title,
        description,
        isRequired,
        isDisabled,
        isReadOnly,
        itemId,
        fieldId,
        isSingleSelect,
        value: selectedItems,
    } = props

    const [isLoading, setIsLoading] = React.useState(false)
    const { isLoading: globalIsLoading } = useAppSelector(
        (state: GlobalState) => state.fields,
    )

    const {
        ItemPickerAddItem,
        ItemPickerEditItem,
        ItemPickerEditItems,
        ItemPickerAddItems,
    } = Labels
    const { Error: ExcError } = Exceptions
    return (
        <div className="tw-w-full">
            <FieldItems
                label={title}
                description={
                    <HTMLAndInternalLinkParser
                        content={(description as string) ?? ""}
                    />
                }
                labelProps={{ isRequired }}
            >
                <NewTable.Table tableId={fieldId}>
                    <NewTable.Body>
                        {selectedItems?.map((item) => {
                            return (
                                <NewTable.Row key={item.id}>
                                    <NewTable.DataCell className="">
                                        <div className="tw-flex-col ">
                                            <ItemAncestry id={item.id} />
                                            <p>
                                                <ActionAnchor
                                                    isLabel={false}
                                                    href={itemDetailUrl(
                                                        env.applicationPath,
                                                        "",
                                                        item.id,
                                                    )}
                                                    extraClasses={`tw-text-black extended tw-static  ${
                                                        isLoading
                                                            ? "is-loading"
                                                            : ""
                                                    }`}
                                                >
                                                    {item.title}
                                                </ActionAnchor>
                                            </p>
                                        </div>
                                    </NewTable.DataCell>
                                </NewTable.Row>
                            )
                        })}
                        {!isReadOnly && (
                            <NewTable.Row>
                                <NewTable.DataCell
                                    style={{
                                        border: "0.065rem dashed #e2e2e2",
                                        background: "white",
                                    }}
                                >
                                    <Action
                                        isDisabled={isDisabled}
                                        isLoading={isLoading || globalIsLoading}
                                        isReadOnly={false}
                                        isLabel={false}
                                        actionType={ActionType.action}
                                        isTransparent={false}
                                        isSecondary={false}
                                        extraClasses="tw-w-full tw-py-2"
                                        onClick={(): void => {
                                            setIsLoading(true)
                                            const ovl = new window.Overlay(
                                                window.Overlay.topmost,
                                            ).setCallback(
                                                async function (
                                                    selectedIdsAsStrings: string[],
                                                ): Promise<void> {
                                                    try {
                                                        const selectedIds =
                                                            selectedIdsAsStrings.map(
                                                                (id: string) =>
                                                                    parseInt(
                                                                        id,
                                                                    ),
                                                            )
                                                        dispatch(
                                                            updateField({
                                                                field: props,
                                                                newValue:
                                                                    selectedIds,
                                                            }),
                                                        )
                                                    } catch (error) {
                                                        dispatch(
                                                            addErrorNotification(
                                                                `${ExcError} ${error.message}`,
                                                            ),
                                                        )
                                                    } finally {
                                                        ovl.remove()
                                                    }
                                                }.bind(this),
                                                () => {
                                                    ovl.remove()
                                                    dispatch(
                                                        addErrorNotification(
                                                            ExcError,
                                                        ),
                                                    )
                                                },
                                            )

                                            ovl.setAfterClose(() => {
                                                setIsLoading(false)
                                            })

                                            ovl.load(
                                                window.TenForce.Execution.Web
                                                    .Ajax.Service
                                                    .ShowMultilevelSelectOverlay,
                                                window.Overlay.instanceCounter,
                                                itemId,
                                                "",
                                                fieldId.replace("CF", ""),
                                                "0",
                                                0,
                                                selectedItems
                                                    .map(
                                                        (selectedItem) =>
                                                            selectedItem.id,
                                                    )
                                                    .join(","),
                                                !isSingleSelect,
                                                null,
                                                null,
                                            )
                                        }}
                                    >
                                        {selectedItems.length > 0 &&
                                            isSingleSelect &&
                                            ItemPickerEditItem}
                                        {selectedItems.length > 0 &&
                                            !isSingleSelect &&
                                            ItemPickerEditItems}
                                        {selectedItems.length === 0 &&
                                            isSingleSelect &&
                                            ItemPickerAddItem}
                                        {selectedItems.length === 0 &&
                                            !isSingleSelect &&
                                            ItemPickerAddItems}
                                    </Action>
                                </NewTable.DataCell>
                            </NewTable.Row>
                        )}
                    </NewTable.Body>
                </NewTable.Table>
            </FieldItems>
        </div>
    )
}

export default ItemPicker
